import { RouteObject } from "../../../interfaces/navigation";
import EntryPoint from "../../../containers/Profile/MyPublications/MyPublicationsContainer";
import EntryPointBrand from "../../../containers/Profile/BrandMyPublicationsContainer/MyPublicationsContainer";
import Management from "../../../containers/Profile/MyPublications/Management/ManagementContainer";
import Detail from "../../../containers/Profile/BrandMyPublicationsContainer/Detail/EntryPointContainer";
import Edit from "../../../containers/Profile/BrandMyPublicationsContainer/Edit/EntryPointContainer";

export const myPublicationsSubRoutes: RouteObject[] = [
    {
        title: "Detalle",
        path: ":id/detail",
        component: <Detail/>
    },
    {
        title: "Editar",
        path: ":id/edit",
        component: <Edit/>
    },
    {
        title: "Gestión",
        path: ":id/management",
        component: <Management/>
    }
];

export const myPublicationsBrandRoutes: RouteObject[] = [
    {
        title: "Mis Publicaciones",
        path: "my_publications_brand",
        component: <EntryPointBrand/>,
        subRoutes: myPublicationsSubRoutes
    }
];